import {NgModule} from '@angular/core';
import {AuthModule} from './authorization/auth.module';
import {AutoLogoutModule} from './autologout/auto-logout.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [AuthModule, AutoLogoutModule],
    exports: [AuthModule, AutoLogoutModule]
})
export class SecurityModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/security.module.ts